import { useState, useCallback, useMemo } from 'react'
import redirect from '../../utils/redirect'
import * as steps from '../../constants/steps'
import { LoginPage, MFA, MFASelector } from '../../pages'
import { LoginContext } from '../../contexts/Login'
import '../../../assets/css/index.css'

const currentTimeSeconds = () => new Date().getTime() / 1000

const Root = props => {
  const [step, setStep] = useState(steps.LOGIN_FORM)
  const [loginTimestamp, setLoginTimestamp] = useState(currentTimeSeconds())
  const [selectedMFA, setSelectedMFA] = useState(null)
  const [mfas, setMFAsState] = useState([])
  const [credentials, setCredentials] = useState({ username: '', password: '' })

  const changeStep = useCallback(newStep => setStep(newStep), [])

  const selectMFA = useCallback(
    mfaType =>
      setSelectedMFA(
        current => mfas.find(mfa => mfa.type === mfaType) || current
      ),
    [mfas]
  )

  const setMFAs = useCallback(newMfas => {
    setMFAsState(newMfas)
    setLoginTimestamp(currentTimeSeconds())
  }, [])

  const updateCredentials = useCallback((field, value) => {
    setCredentials(prev => ({ ...prev, [field]: value }))
  }, [])

  const getSelectedMFA = useCallback(() => selectedMFA || mfas[0], [
    selectedMFA,
    mfas
  ])

  const contextValue = useMemo(
    () => ({
      step,
      loginTimestamp,
      selectedMFA,
      mfas,
      credentials,
      updateCredentials,
      changeStep,
      setMFAs,
      selectMFA
    }),
    [
      step,
      loginTimestamp,
      selectedMFA,
      mfas,
      credentials,
      updateCredentials,
      changeStep,
      setMFAs,
      selectMFA
    ]
  )

  const renderStep = currentStep => {
    return {
      [steps.LOGIN_FORM]: <LoginPage {...props} />,
      [steps.MFA]: (
        <MFA
          mfa={getSelectedMFA()}
          loginTimestamp={loginTimestamp}
          changeStep={changeStep}
          redirect={redirect}
          {...props}
        />
      ),
      [steps.MFA_SELECTOR]: (
        <MFASelector
          mfas={mfas}
          changeStep={changeStep}
          selectMFA={selectMFA}
          redirect={redirect}
          {...props}
        />
      )
    }[currentStep]
  }

  return (
    <LoginContext.Provider value={contextValue}>
      {renderStep(step)}
    </LoginContext.Provider>
  )
}

export default Root
